import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { FindTenderStageQueryResponse, FindTenderStageQueryParams } from "../../types/FindTenderStage";

/**
     * @link /api/purchase-tenders/private/v1/stage
     */
export async function findTenderStage (params: FindTenderStageQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<FindTenderStageQueryResponse>["data"]> {
    const { data: resData } = await client<FindTenderStageQueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/private/v1/stage`,
        params,
        ...options
    });
    
    return resData;
};